import { useCallback, useEffect, useContext } from 'react';
import { logForOpenPage, Logger } from '.';
import { browser } from '../common';
import { brandContext } from '../store/brandContext';
import { isForcedMobileCOM } from '../helpers/isForcedMobileCOM';
import { APP_IDS, EVENT_SOURCES } from '../const';
import { getAppId } from '../helpers/getAppId';

export const useSetupLogs = ({ kafkaStore, referrer, imprintHash }) => {
  const brandName = useContext(brandContext);

  const getDeviceInfo = useCallback(() => {
    if (isForcedMobileCOM()) {
      return { appId: APP_IDS.ComMobile, eventSource: EVENT_SOURCES.mobile };
    }

    const isMobile = browser().mobile;

    const appId = getAppId(brandName, isMobile);
    const eventSource = isMobile ? EVENT_SOURCES.mobile : EVENT_SOURCES.desktop;

    return { appId, eventSource };
  }, [brandName]);

  const handleDeviceInfo = useCallback(() => {
    /**
     * Определяем открыт ли лендинг в PWA.
     *
     * Если открыто в PWA то нам из него приходит appId и мы сохраняем значение в LS
     */
    const storageAppId = localStorage.getItem('appId');

    if (storageAppId === '29') {
      Logger.setAppId(APP_IDS.ComPWA);
      Logger.setEventSource(EVENT_SOURCES.mobile);

      return;
    }

    const { appId, eventSource } = getDeviceInfo();
    Logger.setAppId(appId);
    Logger.setEventSource(eventSource);
  }, [getDeviceInfo]);

  const setupLogs = useCallback(async () => {
    if (!referrer || !imprintHash) {
      return;
    }

    handleDeviceInfo();
    await Logger.init();

    kafkaStore.setImprintHash(imprintHash);
    Logger.setImprint(imprintHash);
    logForOpenPage(referrer, imprintHash);
  }, [referrer, imprintHash]);

  useEffect(() => {
    setupLogs();
  }, [setupLogs]);
};
